import { Component, OnInit, Output, EventEmitter, SimpleChanges, Input, OnChanges } from '@angular/core';

import * as Utils from '@shared/core/utils';

@Component({
    selector: 'shared-hints-floating',
    templateUrl: './hints-floating.shared.component.html',
    styleUrls: ['./hints-floating.shared.component.scss']
})
export class HintsFloatingComponent implements OnInit, OnChanges {
    @Input() public messages: OLO.Components.IMappedMessage = {};
    @Input() public hSide: 'left' | 'right' | 'center' = 'right';
    @Input() public vSide: 'top' | 'bottom' | 'center' = 'bottom';
    @Input() public feel: OLO.Components.MESSAGES_TYPE = 'danger';
    @Input() public size: OLO.Components.FORM_HINTS_SIZE = null;
    @Input() public button: string = null;

    public defaultButton: string = '';
    public message: string = '';

    @Output() public onButtonClick: EventEmitter<Event> = new EventEmitter();

    constructor() { }

    ngOnInit(): void { }

    ngOnChanges(changes: SimpleChanges): void {
        this._mapErrorMessage();
    }

    private _mapErrorMessage(): void {
        this.defaultButton = '';
        if (!this.messages) {
            this.message = '';

            return;
        }

        const mappedErrors: OLO.Components.IMappedMessage[] = Utils.Messages.mapErrors(this.messages);
        const currentError = mappedErrors[0];

        this.message = currentError.message;
        this.feel = currentError.messageType;
        console.warn(this.message, mappedErrors);
        /* Handle buttons */
        switch (currentError.key) {
            case 'cardChange':
                // this.defaultButton = 'Change card';
                break;

            case 'cardRetry':
                this.defaultButton = 'Retry card';
                break;

            case 'cardTaken':
            case 'phoneTaken':
                this.defaultButton = 'Sign in';
                break;

            case 'emailTaken':
                this.defaultButton = 'Sign in';
                break;
        }
    }

    public handleButtonClick($event: Event): void {
        this.onButtonClick.emit($event);
    }
}
